export default __webpack_public_path__ + "static/media/p3-16.a159cac2.png";